'use strict'
import React from 'react'
import GoogleInputField from '../google-input-field.jsx'
import { withTranslation as translate } from 'react-i18next'
import SearchModal from '../search-modal.jsx'

class SmallPageSearch extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      searchModalOpen: false
    }
    this.onRequestCloseModal = this.onRequestCloseModal.bind(this)
    this.onSearchInputClick = this.onSearchInputClick.bind(this)
    this.onSearchClick = this.onSearchClick.bind(this)
  }

  onRequestCloseModal () {
    this.setState({
      searchModalOpen: false,
    })
  }

  onSearchInputClick () {
    this.setState({searchModalOpen: true})
  }

  onSearchClick () {
    this.onRequestCloseModal()
    this.props.onSearchClick()
  }

  render () {
    const _t = this.props.t
    const cta = (this.props.displayMode && this.props.displayMode === 'landing') ?
    (
      <button onClick={this.onSearchInputClick}>{_t('landing_page_search_button')}</button>
    ) : null;
    return (
      <div className='search small-page-search'>
        <GoogleInputField 
          placeholder={this.props.t('landing_page_search_placeholder')}
          value={this.props.searchQuery}
          onClick={this.onSearchInputClick}
          ref={this.props.onSearchInputReady}
          readOnly={true}
        />
        {cta}
        <SearchModal
        locale={this.props.state.locale}
          isOpen={this.state.searchModalOpen}
          searchQuery={this.props.searchQuery}
          onSearchQueryChange={this.props.onSearchQueryChange}
          onRequestClose={this.onRequestCloseModal}
          onChangeMobilityIcon={this.props.onMobilityClassChange}
          mobilityClass={this.props.mobilityClass}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onDatesChange={this.props.onDatesChange}
          onChangeNrGuests={this.props.onChangeNrGuests}
          nrGuests={this.props.nrGuests}
          onSearchClicked={this.onSearchClick}
        />
      </div>
    )
  }
}

export default translate()(SmallPageSearch)
